// eslint-disable-next-line import/no-anonymous-default-export
export default {
    SHOW_NOTIFICATION: "SHOW_NOTIFICATION",
    RESET_NOTIFICATION: "RESETE_NOTIFICATION"
}